import React from 'react';
import './styles/DesignerStyles.css';

import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

import DesignerButton from './DesignerButton';
//import BackgroundSvgComponent from './BackgroundSvgComponent';

import { CountdownCircleTimer } from 'react-countdown-circle-timer';

import { checkForCode, getRoomId } from './Utils';

import clockEndSound from './Sounds/digital-clock-beep.wav';
import correctAnswerSound from './Sounds/correct-answer-tone.wav';
import pageTurnSound from './Sounds/page-turn.wav';

class Game extends React.Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);

    // eslint-disable-next-line
    const { cookies } = props;
    this.clockEndSound = new Audio(clockEndSound);
    this.correctAnswerSound = new Audio(correctAnswerSound);
    this.pageTurnSound = new Audio(pageTurnSound);

    this.state = {
      isLastWord: false,
      timeoutID: 0,

      room: {},

      pulledWordsArray: [],
      currentIndex: 0,

      myTeamIndex: '',

      wordNotGuessedButton: false,
      clockKey: 0,
      areSecondsZero: false,

      timeLeft: 0,
    };
  }

  onPause = () => {
    console.log("App paused");
    if (this.state.timeoutID) {
      clearTimeout(this.state.timeoutID);
    }
  }

  onResume = () => {
    console.log("App resumed");
    if (this.state.room && this.state.room._id) {
       console.log("Forcing immediate loadPage on resume");
       if (this.state.timeoutID) clearTimeout(this.state.timeoutID);
       this.loadPage(); 
    } else {
       console.log("Resumed but no room ID yet.");
    }
 }

  componentDidMount() {
    checkForCode('GET', `/api/rooms/${getRoomId()}`, this.props, null).then(
      (data) => {
        let myTeamIndex;

        data.teams.forEach((team, index) => {
          team.teamPlayers.forEach((teamPlayer) => {
            if (teamPlayer.sub === this.props.cookies.get('code')) {
              myTeamIndex = index + 1;

              index = data.teams.length;
            }
          });
        });

        this.setState({
          room: data,
          myTeamIndex: myTeamIndex,
        });
      }
    );
    document.addEventListener('pause', this.onPause, false);
    document.addEventListener('resume', this.onResume, false);
  }

  componentWillUnmount() {
    document.removeEventListener('pause', this.onPause, false);
    document.removeEventListener('resume', this.onResume, false);
  }

  getNewWord = async () => {
    this.pageTurnSound.play();

    let data = await checkForCode(
      'GET',
      `/api/rooms/${getRoomId()}/words/randomWord`,
      this.props,
      null
    );

    if (data.newWord !== '') {
      let updatedPulledWordsArray = [
        ...this.state.pulledWordsArray,
        data.newWord,
      ];

      this.setState({
        isLastWord: data.isLast,
        currentIndex: updatedPulledWordsArray.length - 1,
        pulledWordsArray: updatedPulledWordsArray,
      });
    }

    return data.newWord;
  };

  handleGuessedWord = () => {
    this.correctAnswerSound.play();

    if (this.state.areSecondsZero === true) {
      this.clockEndSound.pause();
    }

    let guessedWord = this.state.pulledWordsArray[this.state.currentIndex];
    this.setState(
      (prevState) => ({
        pulledWordsArray: prevState.pulledWordsArray.filter(
          (word, index) => index !== prevState.currentIndex
        ),
      }),
      () => {
        let body = JSON.stringify({
          guessedWord: guessedWord,
          areSecondsZero: this.state.areSecondsZero,
        });

        checkForCode(
          'PUT',
          `/api/rooms/${getRoomId()}/words/wordGuessed`,
          this.props,
          body
        ).then(async (data) => {
          if (!this.state.areSecondsZero) {
            if (data.newWord !== '') {
              this.state.pulledWordsArray.push(data.newWord);

              this.setState({
                isLastWord: data.isLast,
                currentIndex: this.state.pulledWordsArray.length - 1
              });
            } else if (this.state.currentIndex >= this.state.pulledWordsArray.length) {
              this.setState({
                currentIndex: this.state.pulledWordsArray.length - 1
              });
            }
          }

          if (
            this.state.areSecondsZero === true ||
            (this.state.pulledWordsArray.length === 0 && data.newWord === '')
          ) {
            this.returnWordsToWordsLeftArray();
          }
        });
      }
    );
  };

  didntGuess = () => {
    this.clockEndSound.pause();
    this.returnWordsToWordsLeftArray();
  };

  loadPage = () => {
    checkForCode('GET', `/api/rooms/${getRoomId()}`, this.props, null).then(
      (data) => {
        let myTeamIndex;

        data.teams.forEach((team, index) => {
          team.teamPlayers.forEach((teamPlayer) => {
            if (teamPlayer.sub === this.props.cookies.get('code')) {
              myTeamIndex = index + 1;

              index = data.teams.length;
            }
          });
        });

        if (data.currentRound !== this.state.room.currentRound) {
          this.props.navigate(`/RoundCompleted/${getRoomId()}`);
        }

        if (data.hasTimerStarted === false) {
          this.setState({
            areSecondsZero: false,
            clockKey: this.state.clockKey + 1,
          });
        }

        this.setState({ room: data, myTeamIndex: myTeamIndex });
      }
    );
  };

  nextPhase = () => {
    let body = JSON.stringify({
      timeLeft: this.state.timeLeft,
    });

    checkForCode(
      'PUT',
      `/api/rooms/${getRoomId()}/nextPhase`,
      this.props,
      body
    ).then((data) => {
      this.setState({
        areSecondsZero: false,
        clockKey: this.state.clockKey + 1,
        pulledWordsArray: [],
        currentIndex: 0,
      });

      if (data.currentRound !== this.state.room.currentRound) {
        this.props.navigate(`/RoundCompleted/${getRoomId()}`);
      }
      console.log('nextPhase');
    });
  };

  renderTime = ({ remainingTime }) => {
    // eslint-disable-next-line
    this.state.timeLeft = remainingTime;

    return (
      <div className="timer">
        <div className="text">Време</div>
        <div
          style={{
            fontSize: this.isUserReading() === true ? '40px' : '60px',
          }}
          className="value">
          {remainingTime}
        </div>
      </div>
    );
  };

  handleVolumeButton = () => {
    //skip this functionallity for now
  };

  returnWordsToWordsLeftArray = () => {
    let body = JSON.stringify({
      pulledWordsArray: this.state.pulledWordsArray,
    });

    checkForCode(
      'PUT',
      `/api/rooms/${getRoomId()}/words/returnWordsToWordsLeftArray`,
      this.props,
      body
    ).then(() => {
      this.nextPhase();
    });
  };

  shiftArrayButton = () => {
    this.setState((prevState) => {
      const newIndex =
        (prevState.currentIndex + 1) % prevState.pulledWordsArray.length;
      return { currentIndex: newIndex };
    });
  };

  handleSkipWordButton = async () => {
    if (
      this.state.pulledWordsArray.length <
      this.state.room.passableWords + 1
    ) {
      this.pageTurnSound.play();

      this.getNewWord();
    }
  };

  startTimerForEveryone = () => {
    checkForCode(
      'PUT',
      `/api/rooms/${getRoomId()}/startTimer`,
      this.props,
      null
    ).then((data) => {
      this.setState({ room: data });
    });
  };

  handleStartGameButton = () => {
    //starts the timer
    //changes the text from description to the first word

    this.setState({ areSecondsZero: false });
    this.getNewWord();
    this.startTimerForEveryone();
  };

  isUserReading = () => {
    //checks if this user is reading the words

    if (!this.state.room) {
      console.log('this.state.room is  undefined or null');
      return false;
    }

    if (!this.state.room.currentTeam) {
      console.log('this.state.room.currentTeam is  undefined or null');
      return false;
    }

    if (this.isUserWatching()) {
      return false;
    }

    if (this.isUserGuessing()) {
      return false;
    }

    return true;
  };

  isUserGuessing = () => {
    //this if is here so that the function can work by itself when called
    if (this.isUserWatching()) {
      return false;
    }

    if (this.state.room && this.state.room.owner) {
      //check if they are the same
      let code = this.props.cookies.get('code');
      let result =
        code !==
        this.state.room.teams[this.state.room.currentTeam - 1].teamPlayers[
          this.state.room.teams[this.state.room.currentTeam - 1].index
        ].sub;
      return result;
    }
    return false;
  };

  isUserWatching = () => {
    if (this.state.room.owner) {
      return this.state.room.currentTeam !== this.state.myTeamIndex;
    }
    return false;
  };

  render() {
    clearTimeout(this.state.timeoutID);
    if (this.state.room._id) {
      // eslint-disable-next-line
      this.state.timeoutID = setTimeout(() => {
        this.loadPage();
      }, 1000);
    }

    return (
      <div className="Home">
        <div className="arrowBackButtonDiv_CG">
          <DesignerButton
            class="arrowBackButton refresh"
            disabled={this.state.room.hasTimerStarted && (this.isUserReading() || this.isUserGuessing())}
            onClick={() => {window.location.reload();}}></DesignerButton>
        </div>
        <div className="arrowBackButtonDiv_CG QR">
          <DesignerButton
            class="arrowBackButton"
            disabled={this.state.room.hasTimerStarted && (this.isUserReading() || this.isUserGuessing())}
            onClick={() => {this.props.navigate(`/QRCodePage/${getRoomId()}`);}}></DesignerButton>
        </div>
        {this.state.room.owner ? (
          <>
            <h1 className="H1NewGame">Рунд {this.state.room.currentRound}</h1>

            {this.state.room.currentTeam !== this.state.myTeamIndex ? (
              <>
                <p>Ред на</p>
                <b>
                  {
                    this.state.room.teams[this.state.room.currentTeam - 1]
                      .displayName
                  }
                </b>
              </>
            ) : (
              <></>
            )}

            {this.state.room.currentTeam === this.state.myTeamIndex ? (
              <div className="timer-wrapper">
              <CountdownCircleTimer
                isPlaying={this.state.room.hasTimerStarted}
                duration={
                  this.state.room.timeLeft || this.state.room.timePerRound
                }
                key={this.state.clockKey}
                colors={['#7BE173', '#EBAA07', '#FF5035']}
                size={this.isUserReading() === true ? 180 : 320}
                colorsTime={[
                  this.state.room.timePerRound,
                  this.state.room.timePerRound / 2,
                  0,
                ]}
                onComplete={() => {
                  // eslint-disable-next-line
                  this.state.room.hasTimerStarted = false;
                  this.setState({ areSecondsZero: true });

                  if (this.isUserReading()) {
                    this.clockEndSound.play();
                  }

                  return { shouldRepeat: true };
                }}>
                {this.renderTime}
              </CountdownCircleTimer>
            </div>
            ) : null }
            
            {this.isUserWatching() === false &&
            this.isUserGuessing() === false &&
            this.state.wordNotGuessedButton === false ? (
              <>
                <div className="GamePaperButton">
                  <DesignerButton
                    class="skipWordButton"
                    onClick={this.shiftArrayButton}
                    disabledDelay={0}></DesignerButton>
                  {this.state.room.hasTimerStarted === false &&
                  this.state.areSecondsZero === false ? (
                    <>
                      <b className="GamePaperButtonParagraphBold">
                        Твой ред е!
                      </b>
                      <p className="GamePaperButtonParagraph">
                        Натисни старт, за да започнеш
                      </p>
                    </>
                  ) : (
                    <b className="GamePaperButtonParagraphBold pulledWord">
                      {this.state.pulledWordsArray[this.state.currentIndex]}
                    </b>
                  )}
                </div>

                {this.state.room.hasTimerStarted === false &&
                this.state.areSecondsZero === false ? (
                  <div className="startGameButtonDiv">
                    <DesignerButton
                      class="filledButton"
                      onClick={this.handleStartGameButton}
                      buttonText="Старт"></DesignerButton>
                  </div>
                ) : (
                  <div className="skipAndCorrectButtonsDiv">
                    <DesignerButton
                      style={{ width: ' 40%' }}
                      class="hollowButton"
                      //this should disable the button when there are no more
                      // passes left
                      disabled={
                        this.state.areSecondsZero === true
                          ? false
                          : this.state.pulledWordsArray.length - 1 ===
                              this.state.room.passableWords ||
                            this.state.isLastWord
                      }
                      onClick={
                        this.state.areSecondsZero === true
                          ? this.didntGuess
                          : this.handleSkipWordButton
                      }
                      buttonText={
                        this.state.areSecondsZero === true ? 'Грешка' : 'Пас'
                      }></DesignerButton>
                    <DesignerButton
                      style={{ width: ' 40%' }}
                      class="filledButton"
                      onClick={this.handleGuessedWord}
                      buttonText="Вярно"></DesignerButton>
                  </div>
                )}
              </>
            ) : (
              <></>
            )}
          </>
        ) : (
          <></>
        )}
      </div>
    );
  }
}

export default withCookies(Game);
